import { useEffect } from 'react';
import Lenis from 'lenis';

/**
 * Attaches a Lenis smooth-scroll instance to the window scroll.
 * Use this only in pages that rely on natural window/body scroll
 * (e.g. LandingPage, DashboardPage).
 */
export function useLenis() {
    useEffect(() => {
        const lenis = new Lenis({
            duration: 1.2,
            easing: (t: number) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            smoothWheel: true,
            wheelMultiplier: 1,
            touchMultiplier: 2,
        });

        let rafId: number;
        function raf(time: number) {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        }
        rafId = requestAnimationFrame(raf);

        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
        };
    }, []);
}
